import * as React from 'react';
import { Menu, MenuItem } from "@progress/kendo-react-layout";
import { Popup } from "@progress/kendo-react-popup";

export const ContextMenu = props => {
	React.useEffect(() => {
		document.addEventListener("click", (e) => {
			if (props.showContext && e.target.className !== 'icon-ui-general-three-dots-vertical' && e.target.className !== "recordMenu")
				props.setshowContext(false);
		});
	}, [props.showContext]);
	
	return <Popup show={props.showContext} offset={props.offSet.current} popupClass={'inner-wrapper'} >
		<Menu vertical={true} onSelect={props.rowContextClick} style={{ padding: "5px" }} >
			{props.menuItems.map((x, index) =>
				<MenuItem text={x} key={"context" + index} />
			)}
		</Menu>
	</Popup>;
};